import { useRef, useState } from "react";
import genieGigLogoImageWhite from "../../../assets/images/auth_page/GenieGig_white_orange_G_thumb.png";
import { useAuthPage } from "../useAuthPage";
import MobileAuthFlow from "./MobileAuthFlow";
import MobileAuthForm from "./MobileAuthForm";
import useMobileAuthViewport from "./useMobileAuthViewport";
import useMobileAuthHeroHeight from "./useMobileAuthHeroHeight";
import { AuthFlowType } from "../../../enums/AuthFlowEnums";
import "./MobileAuthPage.scss";

type MobileAuthPageProps = {
    auth: ReturnType<typeof useAuthPage>;
};

type MobileAuthScreen = "login" | "register";

const MobileAuthPage = ({ auth }: MobileAuthPageProps) => {
    const [screen, setScreen] = useState<MobileAuthScreen>("login");
    const sheetRef = useRef<HTMLElement>(null);
    useMobileAuthViewport();
    useMobileAuthHeroHeight(sheetRef);

    const isLogin = screen === "login";

    const switchScreen = () => {
        if (isLogin) auth.handleMobileSwitchToRegister();
        else auth.handleMobileSwitchToLogin();
        setScreen(isLogin ? "register" : "login");
    };

    const activeFlow = auth.showEmailOTPVerificationModal
        ? AuthFlowType.Registration
        : auth.showResetPasswordModal
            ? AuthFlowType.PasswordReset
            : null;

    const closeActiveFlow = () => {
        if (activeFlow === AuthFlowType.Registration) auth.setShowEmailOTPVerificationModal(false);
        else auth.setShowResetPasswordModal(false);
    };

    return (
        <main className="mobile-auth-page">
            <section className="mobile-auth-hero" aria-hidden="true">
                <h1>The Freelance<br />Revolution<br />Is Here.</h1>
                <img src={genieGigLogoImageWhite} alt="" />
            </section>

            <section className="mobile-auth-sheet" aria-label="Authentication" ref={sheetRef}>
                {activeFlow ? (
                    <MobileAuthFlow
                        key={activeFlow}
                        type={activeFlow}
                        email={activeFlow === AuthFlowType.Registration ? auth.registerEmail : ""}
                        name={auth.name}
                        password={auth.registerPassword}
                        honeypot={auth.registerHoneypot}
                        onClose={closeActiveFlow}
                        onPasswordResetComplete={auth.passwordResetCompletion}
                    />
                ) : (
                    <MobileAuthForm key={screen} auth={auth} isLogin={isLogin} onSwitchScreen={switchScreen} />
                )}
            </section>
        </main>
    );
};

export default MobileAuthPage;